import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=4184041c&scoped=true&"
import script from "./SaveButton.vue?vue&type=script&lang=ts&"
export * from "./SaveButton.vue?vue&type=script&lang=ts&"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=4184041c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184041c",
  null
  
)

export default component.exports